export default __webpack_public_path__ + "static/media/HighOnLove.831f8f60.png";